<template>
  <b-tabs
    vertical
    content-class="col-12 col-md-9 mt-1 mt-md-0"
    pills
    nav-wrapper-class="col-md-3 col-12"
    nav-class="nav-left"
  >

    <!-- general tab -->
    <b-tab active>

      <!-- title -->
      <template #title>
        <mdicon
          name="card-bulleted-outline"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">Plan</span>
      </template>
      <subscription-plan/>
    </b-tab>
    <!--/ general tab -->

  </b-tabs>
</template>

<script>
import SubscriptionPlan from './SubscriptionsPlan.vue'

export default {
  components: { SubscriptionPlan }
}
</script>
